import {
  GeneratePaymentLinkMutation,
  GeneratePaymentLinkMutationVariables,
} from '@/types';
import { GET_PAYMENT_LINKS_QUERY } from './use-get-payment-links';
import { getOperationName } from 'apollo-utilities';
import { gql, useMutation } from '@apollo/client';

export const GENERATE_PAYMENT_LINK_MUTATION = gql`
  mutation GeneratePaymentLink(
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
    $orderInvoiceAmounts: [OrderInvoiceAmountInput!]!
    $creditMemoAmounts: [CreditMemoAmountInput!]!
  ) {
    generatePaymentLink(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
      order_invoice_amounts: $orderInvoiceAmounts
      credit_memo_amounts: $creditMemoAmounts
    ) {
      payment_link_url
    }
  }
`;

export const useGeneratePaymentLink = () => {
  return useMutation<
    GeneratePaymentLinkMutation,
    GeneratePaymentLinkMutationVariables
  >(GENERATE_PAYMENT_LINK_MUTATION, {
    refetchQueries: [getOperationName(GET_PAYMENT_LINKS_QUERY) as string],
  });
};
